import {
  LandingAgeRequirement,
  LandingBackgroundType,
  LandingConfigDto,
  LandingFieldKey,
  LandingPoweredBy,
  LandingSocialNetwork,
} from '../dto';

interface DefaultFieldSeed {
  key: LandingFieldKey;
  label: string;
  visible: boolean;
  required: boolean;
}

/** Standard registration fields shown when a new landing page is created. */
export const DEFAULT_LANDING_FIELDS: DefaultFieldSeed[] = [
  {
    key: LandingFieldKey.FirstName,
    label: 'First Name',
    visible: true,
    required: true,
  },
  {
    key: LandingFieldKey.LastName,
    label: 'Last Name',
    visible: true,
    required: true,
  },
  { key: LandingFieldKey.Email, label: 'Email', visible: true, required: true },
  {
    key: LandingFieldKey.PhoneNumber,
    label: 'Phone Number',
    visible: true,
    required: true,
  },
  {
    key: LandingFieldKey.RegistrationCode,
    label: 'Registration / Invite Code',
    visible: false,
    required: false,
  },
  {
    key: LandingFieldKey.DateOfBirth,
    label: 'Date of Birth',
    visible: true,
    required: true,
  },
];

/** Fields that are always visible and required; their switches are locked in the builder. */
export const LOCKED_LANDING_FIELD_KEYS: string[] = [
  LandingFieldKey.DateOfBirth,
];

export const DEFAULT_SOCIAL_NETWORK = LandingSocialNetwork.Instagram;

/** Default config used to seed the builder form for a brand-new landing page. */
export const DEFAULT_LANDING_CONFIG: LandingConfigDto = {
  brand: {
    logoUrl: null,
    headline: '',
    description: '',
    primaryButtonText: 'Register Now',
    secondaryLinkText: null,
    secondaryLinkUrl: null,
    programDetailsUrl: null,
  },
  fields: DEFAULT_LANDING_FIELDS.map((field) => ({
    ...field,
    custom: false,
  })),
  security: {
    ageGateEnabled: true,
    ageRequirement: LandingAgeRequirement.Over21,
    captchaEnabled: true,
    termsUrl: null,
    termsLinkText: 'Terms & Conditions',
    termsOpenInNewTab: true,
    privacyUrl: null,
    privacyLinkText: 'Privacy Policy',
    privacyOpenInNewTab: true,
  },
  design: {
    backgroundType: LandingBackgroundType.Image,
    backgroundImageUrl: null,
    backgroundColor: '#F6F7F8',
  },
  typography: {
    pageBackgroundColor: '#F6F7F8',
    formBackgroundColor: '#FFFFFF',
    primaryColor: '#1E7A43',
    buttonTextColor: '#FFFFFF',
    headerColor: '#FFFFFF',
    headlineColor: '#1A1A1A',
    descriptionColor: '#4A4A4A',
    textColor: '#1A1A1A',
    labelColor: '#555555',
    placeholderColor: '#A0AAA0',
    borderColor: '#E5E7EB',
    footerTextColor: '#FFFFFF',
    socialIconColor: '#FFFFFF',
  },
  footer: {
    poweredBy: LandingPoweredBy.MjPoints,
    brandName: null,
    showSocialLinks: true,
    showTerms: true,
    showPrivacy: true,
    socialLinks: [],
  },
};
